import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UnmutedCameraIcon } from '@streamr/tv-ui';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { Button } from '../components/Button';
import { Frame } from '../components/Frame';
import { BroadcastStateService } from '../services/broadcaststate/BroadcastStateService';
export function ErrorPage(props) {
    const { description, title } = props;
    const navigate = useNavigate();
    const activateBroadcast = () => {
        BroadcastStateService.getInstance().notifyActivateBroadcast(undefined, navigate);
    };
    return (_jsx(NotFoundPageRoot, { children: _jsx(NotFoundFrameRoot, { children: _jsx(Content, { children: _jsxs(Inner, { children: [_jsx(Title, { children: title }), _jsx(Desc, { children: description }), _jsxs(Buttons, { children: [_jsx(Button, { type: "button", kind: "secondary", size: "big", onClick: () => {
                                        navigate('/');
                                    }, children: "Return to home screen" }), _jsx(Button, { type: "button", size: "big", icon: _jsx(UnmutedCameraIcon, { fill: "#f65f0a" }), onClick: activateBroadcast, children: "Broadcast" })] })] }) }) }) }));
}
const Buttons = styled.div `
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr;
    margin-top: clamp(2.5rem, 11.71875vw, 3.75rem);
    width: 100%;

    button {
        padding: 0 1.5rem;
    }

    @media (min-width: 32rem) {
        grid-template-columns: auto 1fr;
    }
`;
const Title = styled.div `
    font-size: clamp(1rem, 7vw, 2rem);
    line-height: 1.35em;
    font-weight: 500;
    text-align: center;
`;
const Desc = styled.div `
    font-size: clamp(0.75rem, 4vw, 1.125rem);
    line-height: 1.35em;
    margin-top: clamp(2rem, 10vw, 2.5rem);
    text-align: center;
`;
const Inner = styled.div `
    max-width: 28rem;
`;
const Content = styled(Frame) `
    color: #ffffff;
    margin: 0 auto;
    min-width: 0;
    width: 100%;
`;
const NotFoundFrameRoot = styled.div `
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    max-width: 100%;
    padding: 2rem 1.75rem;
    width: 45rem;
    min-height: 100vh;
`;
const NotFoundPageRoot = styled.div `
    color: #ffffff;
    overflow: auto;
`;
